import { OptionOf } from '~/components/molecule/Dropdown';

export const PAYMENT_OPTIONS: Array<OptionOf<'SEPA'>> = [
  {
    label: 'SEPA automatische incasso',
    payload: 'SEPA',
    key: 'SEPA',
  },
];
